import { render, staticRenderFns } from "./Simple.vue?vue&type=template&id=6ea10610&scoped=true"
import script from "./Simple.vue?vue&type=script&lang=js"
export * from "./Simple.vue?vue&type=script&lang=js"
import style0 from "./Simple.vue?vue&type=style&index=0&id=6ea10610&prod&lang=scss&scoped=true"
import style1 from "./Simple.vue?vue&type=style&index=1&id=6ea10610&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea10610",
  null
  
)

export default component.exports